import { WithToolTip } from "@atlas/core";

export function truncatingHeaderTitle(label: string): string {
  return (
    <WithToolTip tooltipText={label}>
      <span className="inline-block max-w-32 truncate align-middle">
        {label}
      </span>
    </WithToolTip>
  ) as unknown as string;
}
